<template>
  <sidebar-item :link="{name: $t('Коммерческие условия'),  path: `/commercialTerms`,  icon: 'vip_icon icon_policy'}">
  </sidebar-item>
</template>
<script>
    export default {
        name: 'CommercialTermsMenu',
    }
</script>
